// eslint-disable-next-line import/prefer-default-export
export const UserLicense = Object.freeze({
    Employee: 0,
    Manager: 1,
    AdvancedScheduling: 2,
});

// TODO - there are more licenses on UKG. Add them here as we need them on development.
export const UserLicenseNames = Object.freeze({
    [UserLicense.Employee]: 'employee',
    [UserLicense.Manager]: 'manager',
    [UserLicense.AdvancedScheduling]: 'advanced scheduling',
});
